import Notification from './notification';

class ErrorHandler {
  handle(error) {
    const { status } = error.response;
    const method = this.formatForExecution(error.response);
    const { data } = error.response;
    if (
      status === 400
      || status === 401
      || status === 403
      || status === 404
      || status === 422
      || status === 500) {
      if (typeof this[method] === 'function') {
        this[method](data);
      }
    } else if (status > 400 && status < 500 && !this[method]) {
      this.UnhandledError(data);
    }
  }

  formatForExecution(error) {
    // eslint-disable-next-line camelcase
    const arr_to_split = error.data.error || error.statusText;
    const arr = arr_to_split.split(' ');
    let funcName = '';
    arr.forEach((word) => {
      funcName += word.charAt(0).toUpperCase() + word.substr(1);
    });
    return funcName;
  }

  InternalServerError(error) {
    return new Notification('error', error.error || 'Error', error.message);
  }

  Unauthorized(error) {
    if (error.message === 'Bad credentials, please verify that your username/password are correctly set: Bad credentials, please verify that your username/password are correctly set') {
      document.querySelector('#form-username').classList.add('error');
      document.querySelector('#form-password').classList.add('error');
    }
    if (error.message === 'Expired JWT Token: Expired JWT Token') {
      error.message = 'Session expired. Please login again.';
    }
    return new Notification('error', error.error || 'Error', error.message);
  }

  BadRequest(error) {
    return new Notification('error', error.error || 'Error', error.message);
  }

  UnprocessableEntity(error) {
    return new Notification('error', error.error || 'Error', error.message);
  }

  UnhandledError(error) {
    return new Notification('error', error.error || 'Error', error.message);
  }
}

export default ErrorHandler;
